import { ActionPointData, SurveyTopic, SurveyTopicIdentifier } from "..";

export const ActionPlanTopicTypes = [ 'Basic', 'WPA', 'AgendaItem' ] as const;
export type ActionPlanTopicType = typeof ActionPlanTopicTypes[number];

export const ActionPlanRiskConsequences = ['1 - small', '2 - significant', '3 - severe', '4 - catastrophic'] as const;
export type ActionPlanRiskConsequence = typeof ActionPlanRiskConsequences[number];

export const ActionPlanRiskLikelihoods = ['1 - unlikely', '2 - rare', '3 - possible', '4 - likely'] as const;
export type ActionPlanRiskLikelihood = typeof ActionPlanRiskLikelihoods[number];

export const RiskCategories = [ 'Acceptabel risiko', 'Lille risiko', 'Moderat risiko', 'Høj risiko'] as const;
export type RiskCategory = typeof RiskCategories[number];

type CommonActionPlanTopic = {
    id: string,
    description:string,
    actionPoints:ActionPointData[],
    risk: {
        consequence: ActionPlanRiskConsequence,
        likelihood: ActionPlanRiskLikelihood
    }
}

type BasicActionPlanTopicTypeData =  { 
    type:'Basic',
}

type SurveyActionPlanTopicTypeData = { 
    type:'WPA', 
    customData:{
        surveyTopicIdentifier:SurveyTopicIdentifier 
    }
};

type AgendaItemActionPlanTopicTypeData = { 
    type:'AgendaItem',
    customData:{
        agendaItemId:string
    }
};

export type ActionPlanTopicTypeData = 
    BasicActionPlanTopicTypeData |
    SurveyActionPlanTopicTypeData |
    AgendaItemActionPlanTopicTypeData;

    
export type SimpleActionPlanTopic = CommonActionPlanTopic &  ActionPlanTopicTypeData;
 
export type BasicActionPlanTopic = CommonActionPlanTopic & BasicActionPlanTopicTypeData;
export type SurveyActionPlanTopic = CommonActionPlanTopic & SurveyActionPlanTopicTypeData &
{
    surveyTopic:SurveyTopic
}
export type AgendaItemActionPlanTopic = CommonActionPlanTopic & AgendaItemActionPlanTopicTypeData;

export type ActionPlanTopic = 
    BasicActionPlanTopic | 
    SurveyActionPlanTopic | 
    AgendaItemActionPlanTopic;